import React from 'react';
import Storage from '../Storage/Storage';

const Form = function (props) {
  const {
    children, onChange, avert, onSubmit, errorMessage, success, infoMessage, ...rest
  } = props;
  return (
    <form
      {...rest}
      onSubmit={e => {
        if (!avert) {
          e.preventDefault();
        }
        onSubmit();
      }}
      onChange={({ target }) => {
        const { name, value, type } = target;
        if (type === 'number' || type === 'range') {
          onChange({ value: parseInt(value, 10), name });
        } else {
          onChange({ value, name });
        }
      }}
    >
      {children}
      {
        !success && errorMessage && (
          <div className="formElement type-alert">
            <label />
            <div className="alert alert-error" role="alert">
              <img src={Storage.get('error')} alt="error" />
              <p>{errorMessage}</p>
            </div>
          </div>
        )
      }
      {
        success && infoMessage && (
          <div className="formElement type-alert">
            <label />
            <div className="alert alert-info" role="alert">
              <img src={Storage.get('success')} alt="info" />
              <p>{infoMessage}</p>
            </div>
          </div>
        )
      }
    </form>
  );
};

export default Form;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/Form.js